module.exports = __webpack_public_path__ + "media/images/bank_images/arbi-2bdf9336d5f876aa84a2c0acb93aaa01.png";